(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["apogon-h5-platform-frontend-main"] = factory();
	else
		root["apogon-h5-platform-frontend-main"] = factory();
})(window, function() {
return 